import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { useCookies } from "vue3-cookies"
import store from '@/store/index'
import { LANGUAGE } from '@/const/language'
import { USER, TOKEN, SETTING_NAVBAR_MODE, SETTING_SIDEBAR_MODE, SETTING_BREAKCRUMB, USER_LOGINED, USER_ROLES } from '@/const/cookie'
import { CHANGE_COUNTRY } from '@/const/store'
import { v4 as uuidv4 } from 'uuid'
import { useRouter } from 'vue-router'
import i18n from '../../createI18n'
import commons from '@/utils/Common'
import messageShow from '@/utils/MessageShow'
import router from '@/router'

const app = createApp({})
app.use(VueAxios, axios)
app.use(i18n)

const service = {
    init() {
        app.axios.defaults.baseURL = process.env.VUE_APP_BASE_API
        app.axios.defaults.headers.common['Content-Type'] = 'application/json'
        let clientMessage = uuidv4()
        app.axios.defaults.headers.common['X-Trace-Id'] = clientMessage
        const { cookies } = useCookies();
        let langCookie = cookies.get(LANGUAGE);
        let tokenUser = commons.getToken();
        console.log('tokenUser', tokenUser)
        if (langCookie != null) {
            store.commit(CHANGE_COUNTRY, langCookie)
        }
        app.axios.defaults.headers.common['Accept-Language'] = langCookie
        if (tokenUser !== null) {
            store.dispatch('setLoggedIn', true)
            // let userLc: any = commons.getToken();
            let token = typeof tokenUser === "string"
                ? JSON.parse(tokenUser)
                : tokenUser;
            if (token != null && token != undefined) {
                app.axios.defaults.headers.common['Authorization'] = token.tokenType + ' ' + token.accessToken;
                app.axios.defaults.headers.common['RefreshToken'] = token.refreshToken;
                app.axios.defaults.headers.common['session'] = token.sessionId;
            }

        } else {
            store.dispatch('setLoggedIn', false)
        }

        let settingNavbarMode = cookies.get(SETTING_NAVBAR_MODE);
        if (settingNavbarMode !== null) {
            store.dispatch('setNavbarVariant', settingNavbarMode)
        }
        let settingSidebarMode = cookies.get(SETTING_SIDEBAR_MODE);
        if (settingSidebarMode !== null) {
            store.dispatch('setSidebarSkin', settingSidebarMode)
        }

        app.axios.interceptors.response.use(
            (response) => response,
            (error) => {
                const res = error.response

                if (!res) return Promise.reject(error)
                

                const data = res.data
               console.log("data =", data);
            console.log("status =", data.status, typeof data.status);
            console.log("statusCode =", data.data?.statusCode, typeof data.data?.statusCode);
            console.log("status == 400", data.status == 400);
            console.log("status === 400", data.status === 400);
                
                // let statusCode = data?.data.statusCode 
                // let status = data?.status 
                // if(status == 400){
                //     console.log('vao day statusCode')
                //     messageShow.errorList("msg." + data.messageCode, data.errorsList, 'topRight')
                // } else {
                //     console.log('vao day status')
                //         if (data?.status === 400) {
                        
                //         messageShow.error(data.title, data.detail, 'topRight')
                //     }
                // }

                if (res.status === 401 || res.status === 403) {
                    // 401 -> refresh token -> lấy access token mới  ->retry request -> thất bại mới logout
                    messageShow.error('Error ' + res.status, 'Authoration')
                    commons.loginErrorAuth()
                    router.push('/login')
                }

                return Promise.reject(error)
            }
        )
        // app.axios.interceptors.response.use((response) => {
        //     return response
        // }, async (error) => {
        //     let res = error.response
        //     let originalRequest = res.data;
        //     console.log('333333', error.response)
        //     if (originalRequest.statusCode == 400) {
        //         messageShow.errorList("msg." +originalRequest.messageCode, originalRequest.errorsList, 'topRight')
        //     }

        //     if (res.status == 403 || res.status == 401) {
        //         // messageShow.errorCommon('Unauthorized', 'topRight')
        //         console.log('22222222')
        //         router.push({ path: '/login' })
        //     }
        // })
    },
    get(resource: any, params: any) {
        return app.axios.get(resource, params).catch(error => {
            const { cookies } = useCookies();
            throw error
        })
    },
    post(resource: any, params: any) {
        return app.axios.post(`${resource}`, params).catch(error => {
            throw error
        })
    },
    patch(resource: any, params: any) {
        return app.axios.patch(`${resource}`, params).catch(error => {
            throw error
        })
    },
    getNoParam(resource: any) {
        return app.axios.get(resource).catch(error => {
            throw error
        })
    },
    getFileNoParam(resource: any) {
        app.axios.defaults.responseType = 'blob';
        return app.axios.get(resource).catch(error => {
            throw error
        })
    },
    // getFileNoParam(resource: string) {
    //     return app.axios.get(resource, {
    //         responseType: 'blob'
    //     })
    // },
    postNoParam(resource: any) {
        return app.axios.post(`${resource}`).catch(error => {
            throw error
        })
    },
    uploadFile(resource: any, params: any) {
        app.axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
        app.axios.defaults.headers.common['s-merchant-id'] = 'TQ2D3BTWQYF3fS5uNmk07JG8RT4w8m6CIbttrYaYN0Q'
        console.log('uploadFile', app)
        return app.axios.post(`${resource}`, params).catch(error => {
            throw error
        })

    },
    // uploadFile(resource: string, params: FormData) {
    //     return app.axios.post(resource, params, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data',
    //             's-merchant-id':
    //                 'TQ2D3BTWQYF3fS5uNmk07JG8RT4w8m6CIbttrYaYN0Q'
    //         }
    //     })
    // },
    deleteNoParam(resource: any) {
        return app.axios.delete(`${resource}`).catch(error => {
            throw error
        })
    }
}
export default service
